export enum CmpConfigCCPAField {
    LSPA = "lspa",
    DISABLED = "disabled",
    APPLY_TO_ALL_STATES = "applyToAllStates"
}
